<div>
  <h5 class="text-muted fw-normal mb-4">
    Per effettuare l'accesso, è necessaria la doppia autenticazione.<br />
    Seleziona il metodo di autenticazione a due fattori che preferisci
    utilizzare.
  </h5>
</div>

<div class="row mt-3 mb-3">
  <div class="col">
    Configura l'app Microsoft Authenticator per IdeaSoftware.
    <div class="mt-3 text-end">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="selectMfaMethod(mfaMethodEnum.MicrosoftAuthenticator)"
      >
        Microsoft Authenticator
      </button>
    </div>
  </div>
</div>
<div class="row mt-3 mb-3">
  <div class="col">
    Ricevi un codice di verifica monouso per e-mail.
    <div class="mt-3 text-end">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="selectMfaMethod(mfaMethodEnum.EmailOtpCode)"
      >
        Email OTP
      </button>
    </div>
  </div>
</div>
